// Random Generator Tool — random numbers in a range + bulk UUID v4 generation.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const randomGeneratorTool: Tool = {
  id: "random-generator",
  name: () => m.rg_tool_name(),
  description: () => m.rg_tool_description(),
  icon: "🎲",
  basePath: "/random-generator",
  status: "stable",
  tags: ["random", "number", "uuid", "generator"],
  pages: [
    {
      name: () => m.rg_nav_main(),
      path: "/random-generator",
      description: () => m.rg_nav_main_desc(),
      icon: "🎲",
    },
  ],
};
